var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.3 186.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0e677a;}.cls-2{fill:#44beda;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 93.15,
    cy: 93.15,
    r: 90.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.15,5A88.15,88.15,0,1,1,5,93.15,88.15,88.15,0,0,1,93.15,5m0-5A93.15,93.15,0,1,0,186.3,93.15,93.26,93.26,0,0,0,93.15,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.42,
    y: 28.79,
    width: 5.45,
    height: 23.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.42,
    y: 134.26,
    width: 5.45,
    height: 23.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.14,
    y: 44.24,
    width: 5.45,
    height: 23.25,
    transform: "translate(-23.14 55.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.71,
    y: 118.81,
    width: 5.45,
    height: 23.25,
    transform: "translate(-54.03 130.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.69,
    y: 81.52,
    width: 5.45,
    height: 23.25,
    transform: "translate(-52.73 133.57) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.15,
    y: 81.52,
    width: 5.45,
    height: 23.25,
    transform: "translate(52.73 239.03) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.14,
    y: 118.81,
    width: 5.45,
    height: 23.25,
    transform: "translate(3.13 262.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.71,
    y: 44.24,
    width: 5.45,
    height: 23.25,
    transform: "translate(183.17 187.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.25,
    y: 32.81,
    width: 5.45,
    height: 23.25,
    transform: "translate(-11.45 31.31) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.6,
    y: 130.24,
    width: 5.45,
    height: 23.25,
    transform: "translate(-45.66 54.17) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.71,
    y: 61.35,
    width: 5.45,
    height: 23.25,
    transform: "translate(-39.99 86.1) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.14,
    y: 101.7,
    width: 5.45,
    height: 23.25,
    transform: "translate(-17.13 201.03) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.71,
    y: 101.7,
    width: 5.45,
    height: 23.25,
    transform: "translate(-43.27 197.75) rotate(-112.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.14,
    y: 61.35,
    width: 5.45,
    height: 23.25,
    transform: "translate(128.74 231.96) rotate(-112.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.25,
    y: 130.24,
    width: 5.45,
    height: 23.25,
    transform: "translate(86.1 300.86) rotate(-157.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.6,
    y: 32.81,
    width: 5.45,
    height: 23.25,
    transform: "translate(201.03 128.85) rotate(-157.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 93.15,
    cy: 93.15,
    r: 35.73
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.28a471d4159c9c7d008fbebc48b69d4a.svg";
export { ForwardRef as ReactComponent };